import { examAdminExecutionAttackDefense } from "./exam-admin-execution-attack-defense";

export const examAdminExecution = {
  pageTitle: "Capture-the-Flag Environment Management",
  submissions: "Code Submissions",
  pageSubtitle:
    "View environment instances, attack & defense runtime states, and programming question judging submissions in one place.",
  submissionsPageSubtitle:
    "View programming judging submissions and administrator try-run records in one place.",
  submissionDetailDefault: "Submission Details",
  submissionDetailTryRun: "Submission Details {id}",
  submissionDetailRecord: "Submission Details #{id}",
  attackDefensePanel: examAdminExecutionAttackDefense,
  sections: {
    environments: "Environment Instances",
    submissions: "Code Submissions",
  },
  stats: {
    environmentTotal: "Environment instances: {count}",
    environmentActive: "Active environments: {count}",
    environmentAnomaly: "Environment anomalies: {count}",
    submissionTotal: "Code submissions: {count}",
    submissionAccepted: "Accepted: {count}",
    submissionNonAccepted: "Non-accepted: {count}",
  },
  filters: {
    activeOnly: "Active environments only",
    anomalyOnly: "Runtime anomalies only",
    status: "Filter by status",
    exam: "Filter by exam",
    candidate: "Filter by candidate",
    nonAcceptedOnly: "Non-accepted only",
    verdict: "Filter by verdict",
  },
  actions: {
    viewAttempt: "View Attempt",
    recycleInstance: "Recycle Instance",
    rejudge: "Rejudge",
    batchRecycle: "Batch recycle selected instances",
    exportEnvironments: "Export current environment results",
    exportSubmissions: "Export current submission results",
    batchRejudge: "Batch rejudge selected questions",
  },
  messages: {
    instanceDestroySubmitted: "Environment instance destroy request submitted",
    batchDestroySubmissionPartial: "Environment destroy requests submitted: {submitted}; failed: {failed}",
    batchDestroySubmissionSuccess: "Environment destroy requests submitted: {count}",
    rejudgeSuccess: "Rejudge completed",
    batchRejudgePartial: "Batch rejudge completed: {success} succeeded, {failed} failed",
    batchRejudgeSuccess: "Batch rejudge completed: {count} total",
  },
  confirm: {
    recycleTitle: "Recycle this environment instance?",
    recycleDescription: "After recycling, the runtime state will switch to destroyed.",
    recycleSubmit: "Recycle",
    batchRecycleTitle: "Batch recycle the selected environment instances?",
    batchRecycleDescription: "Only instances that are not destroyed will be recycled.",
    batchRecycleSubmit: "Batch recycle",
    batchRejudgeTitle: "Batch rejudge the selected questions?",
    batchRejudgeDescription:
      "Deduplicate by attempt_question and generate the latest judging result again.",
    batchRejudgeSubmit: "Batch rejudge",
  },
  table: {
    instanceId: "Instance ID",
    examAttempt: "Exam / Attempt",
    question: "Question",
    types: "Types",
    source: "Source",
    questionVersionCode: "Question Version Code",
    runStatus: "Run Status",
    caseResult: "Case Result",
    operator: "Operator",
    language: "Language",
    memory: "Memory",
    time: "Runtime",
    action: "Action",
    case: "Case",
    input: "Input",
    expectedOutput: "Expected Output",
    actualOutput: "Actual Output",
    errorInfo: "Error Info",
    timeUsedMs: "Time Used (ms)",
    memoryUsedMb: "Memory Used (MB)",
    providerRef: "Provider Ref",
    submissionId: "Submission ID",
    languageAndCount: "Language / Count",
    judgeStatus: "Judge Status",
    submittedAt: "Submitted At",
    questionMeta: "Q#{questionId} / Question {order} / Candidate #{candidateId}",
    examLabel: "Exam #{id}",
    attemptLabel: "Attempt #{id}",
    candidateLabel: "Candidate #{id}",
    adminTryRun: "Admin Try Run",
    unknown: "Unknown",
    contractValueMissing: "Missing",
    sourceTypeContractAnomaly: "Source type contract anomaly: {value}",
    flagModeContractAnomaly: "Flag mode contract anomaly: {value}",
    acceptedSummary: "{passed} passed / {failed} failed",
    codeSnapshot: "Submitted Code",
    caseResults: "Case Results",
    runSuccess: "Run succeeded",
    runFailed: "Run failed",
    runRunning: "Running",
    runStatusContractAnomaly: "Run status contract anomaly: {value}",
    runVerdictContractAnomaly: "Run verdict contract anomaly: {value}",
    caseAccepted: "Passed",
    caseFailed: "Failed",
    caseStatusContractAnomaly: "Case status contract anomaly: {value}",
  },
};
